import { render, staticRenderFns } from "./VehicleTransferDialog.vue?vue&type=template&id=8af5e69e&scoped=true"
import script from "./VehicleTransferDialog.vue?vue&type=script&lang=js"
export * from "./VehicleTransferDialog.vue?vue&type=script&lang=js"
import style0 from "./VehicleTransferDialog.vue?vue&type=style&index=0&id=8af5e69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af5e69e",
  null
  
)

export default component.exports